module.exports = __webpack_public_path__ + "static/img/qybj_03.3cc9149.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/equity/qybj_03.jpg
// module id = 0sVT
// module chunks = 0